<template>
    <div class="add-entry-page" id="add-entry-page">
        <app-loading
            v-if="loading"
        />

        <app-header 
            :position="'fixed'"
            :top="'0px'"
            :background="'transparent'"
            @clickBack="clickBack"
            @clickMenu="change_menu(context, true)"
        />

        <div class="video-page__image"></div>

        <div class="video-page__container">
            <div class="video-page__title"
                v-show="!temporaryData"
            >
                Выберите вступление
            </div>

<!--            <app-player-->
<!--                :id="temporaryData.id"-->
<!--                :video="temporaryData.video"-->
<!--                :webm="temporaryData.webm"-->
<!--                @playVideo="entry_play_video()"-->
<!--            />-->

            <app-player-no-blob
                :id="temporaryData.id"
                :video="temporaryData.video"
                :webm="temporaryData.webm"
                @playVideo="entry_play_video()"
            />
        </div>

        <div class="video-page__footer" id="video-page__footer">
          <carousel
              :per-page="3"
              :mouse-drag="true"
              :paginationEnabled="false"
              :navigateTo="0"
              :spacePadding="16"
          >
            <slide
                v-for="(item, index) in videos"
                :key="item.id"
            >
              <app-one-video
                  :key="`${item.id}__index`"
                  :index="index"
                  :id="item.id"
                  :name="item.name"
                  :text="item.text"
                  :img="item.img"
                  :status="item.status"
                  :textStatus="true"
                  :duration="item.duration"
                  :video="item.video"
                  :type="item.type"
                  :control="item.control"
                  :webm="item.webm"
                  :coef="item.coef"
                  width="108px"
                  height="108px"
                  @clickVideo="(data) => entry_click_video(context, data, 'video-page__container')"
              />
            </slide>
          </carousel>
            <div class="video-page__button"
                v-if="!editeableItem"
                :class="{ 'video-page__button-active' : temporaryData}"
                @click="entry_add_video(context, { store_url: 'entry_video/setVideos', redirect: '/video-editor' })"
            >
                <div class="video-page__button-text"
                    :class="{'video-page__button-text-active' : temporaryData}"
                >
                    Добавить видео
                </div>
            </div>

            <div class="video-page__button"
                v-if="editeableItem"
                :class="{ 'video-page__button-active' : temporaryData}"
                @click="entry_add_video(context,  { store_url: 'entry_video/setVideos', redirect: '/video-editor' })"
            >
                <div class="video-page__button-text"
                    :class="{'video-page__button-text-active' : temporaryData}"
                >
                    Заменить видео
                </div>
            </div>
        </div>

        <transition 
            name="fade-menu" 
            appear
            mode="out-in"
        >
            <app-menu 
                v-if="menu"
                idLogoMenu="header-component__menu"
                @clickLink="change_menu(context, false)"
                @clickOutside="change_menu(context, false)"
            />
        </transition >
        
        <transition 
            name="fade-overlay" 
            appear
            mode="out-in"
        >
            <app-overlay 
                v-if="overlay"
            />
        </transition>

      <transition
          name="fade-overlay"
          appear
          mode="out-in"
      >

        <app-alert
            v-if="error.status"
            buttonText="Вернуться на главную"
            :text="error.text"
            @clickGrowButtonPopup="$router.push('/')"
        />

      </transition>

    </div>
</template>

<script>

    const AppLoading = () => import('@/components/loading.vue')
    const AppHeader = () => import('@/components/header.vue')
    const AppMenu = () => import('@/components/menu.vue')
    const AppOverlay = () => import('@/components/overlay.vue')
    const AppOneVideo = () => import('@/components/one-video.vue')
    const AppPlayer = () => import('@/components/player.vue')
    const AppAlert = () => import('@/components/popups/error')
    const AppPlayerNoBlob = () => import('@/components/onePlayerNoBlob')

    import { Carousel, Slide } from 'vue-carousel';

    import entry_get from "@/views/entry/modules/entry_get";
    import change_menu from "@/views/theme/modules/change_menu";
    import entry_click_video from "@/views/entry/modules/entry_click_video";
    import entry_add_video from "@/views/entry/modules/entry_add_video";
    import entry_play_video from "@/views/entry/modules/entry_play_video";
    
    export default {
        async mounted() {
          await this.entry_get(this)
        },
        destroyed() {
          this.$store.dispatch('cache_videos_page_context/clearCacheVideo')
        },
      data() {
            return {
              context: this,
              menu: false,
              overlay: false,
              rendering: false,
              is_loading_video: false,
              videos: [],
              temporaryData: false,
              swiperOption: {
                slidesPerView: 2.6,
                spaceBetween: 30,
                width: 300,
                centeredSlides: false,
                pagination: {
                  el: '.swiper-pagination',
                  clickable: true
                },
              },
              error: {
                status: false,
                text: ''
              }
            }
        },
        components: {
            AppLoading,
            AppHeader,
            AppMenu,
            AppOverlay,
            Carousel,
            Slide,
            AppOneVideo,
            AppPlayer,
            AppAlert,
            AppPlayerNoBlob
        },
        computed: {
            loading() {
                return !this.videos.length > 0 && this.rendering
            },
            editeableItem() {
                return this.$store.getters['edit/editableItem']
            }
        },
        methods: {
          entry_get,
          change_menu,
          entry_click_video,
          entry_add_video,
          entry_play_video,
          async clickBack() {
            // await this.$router.push('/theme')
            await this.$router.push('/')
          }
        }
    }
</script>

<style lang="less">

    .add-entry-page {
        background-color: black;
        width: 100%;
        height: calc(var(--vh, 1vh) * 100);
        min-height: 500px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-direction: column;
    }

    .add-entry-page .header-component {
        z-index: 10;
    }

    .video-page__image {
        background-image: url('../../assets/space.jpg');
        display: none;
    }

    .video-page__container {
        height: 100%;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    @import '~/assets/fonts/montserrat/Montserrat-Bold.less';

    .video-page__title {
        color: #FFFFFF;
        line-height: 28px;
        font-size: 22px;
        font-family: 'Montserrat-Bold';
        text-align: center;
    }

    #add-entry-page .player-component {
        position: absolute;
    }

    #add-entry-page .VueCarousel {
      min-height: 116px;
      //min-width: 360px;
      overflow: hidden;
    }

    .video-page__footer {
        width: 100%;
        background-color: #2F1F4C;
        position: relative;
        z-index: 10;
    }

    #video-page__footer .VueCarousel-wrapper {
      padding-top: 16px;
    }

    #video-page__footer .VueCarousel-slide {
      max-width: 131px;
      min-width: 131px;
    }

    @import '~/assets/fonts/montserrat/Montserrat-Medium.less';

    .video-page__button {
        height: 44px;
        min-height: 44px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: rgba(255, 255, 255, 0.2);
        border-radius: 5px;
        margin: 0 auto;
        margin-top: 12px;
        margin-left: 16px;
        margin-right: 16px;
        margin-bottom: 16px;
        cursor: pointer;
    }

    .video-page__button-text {
        font-family: 'Montserrat-Medium';
        opacity: .5;
        color:  #FFFFFF;
        line-height: 12px;
        font-size: 16px;
    }

    .video-page__button-active {
        background: #FFFFFF;
    }

    .video-page__button-text-active {
        color: #31283D;
        opacity: 1;
    }

</style>